import { render, staticRenderFns } from "./myService.vue?vue&type=template&id=0668fd5e&scoped=true&"
import script from "./myService.vue?vue&type=script&lang=js&"
export * from "./myService.vue?vue&type=script&lang=js&"
import style0 from "./myService.vue?vue&type=style&index=0&id=0668fd5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0668fd5e",
  null
  
)

export default component.exports